import { render } from "./HistoryView.vue?vue&type=template&id=eefb33c4&ts=true"
import script from "./HistoryView.vue?vue&type=script&lang=ts"
export * from "./HistoryView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__